import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TableComponent} from '../../../../components/table/table.component';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {TableFunctionList} from '../../../../entities/table-function-list.entity';
import {CustomTableFunctionTypeEnum} from '../../../../enums/CustomTableFunctionTypeEnum';
import {Backend} from '@generated-backend-types';
import QmDocument = Backend.App.Resources.Dashboard.QualityManagement.Document;

@Component({
  selector: 'app-authenticated-quality-management-documents-index',
  templateUrl: './index.component.html',
  imports: [TableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  public tableFunctionList: TableFunctionList = {
    privateAttachmentDownload: rowData => {
      const data = rowData as QmDocument;
      if (data && data.url) {
        window.open(data.url, '_blank', 'noopener,noreferrer');
      }
    },
    custom: rowData => {
      return {
        type: CustomTableFunctionTypeEnum.LINK,
        payload: '/quality-management/processes/' + (rowData as QmDocument).process_id + '/current',
        value: (rowData as QmDocument).process?.ext_id ?? undefined,
      };
    }
  }

  public ngOnInit() {
    this.titleService.setTitle('authenticated.quality-management.documents.index.title');
  }
}
